// extracted by mini-css-extract-plugin
export var deliveryRow = "_sa-a";
export var fixedHeight = "_sa-4";
export var freightLogo = "_sa-9";
export var fullWidth = "_sa-3";
export var priceColumn = "_sa-5";
export var radioSelected = "_sa-7";
export var radioUnselected = "_sa-6";
export var selectedOption = "_sa-2";
export var selectedOptionContainer = "_sa-1";
export var selection = "_sa-0";
export var tallSkeletonText = "_sa-8";